<template>
  <el-tabs
    v-model="intab"
    type="card"
    :editable="false"
    @tab-click="onChangeTab"
    class="component-tabs"
    :class="className">
    <el-tab-pane
      v-for="item in tabs"
      :key="item.name"
      :label="item.label"
      :name="item.name"
      tabindex="0">
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import _ from 'lodash'
import Constants from '@/constants'
// import OpeningFormConstants from '@/pages/opportunities/formopening/formconstants'
import Util from '@/util'
// import StringUtil from '@/util/string'
// import FileUtil from '@/util/file'
// import EventBus from '@/controllers/EventBus'
import ElementHelper from '@/util/element'

// import File from '@/apis/file'
// import Upload from '@/apis/upload'

export default {
  name: 'page-opportunity-tabs',
  props: {
    // msg: String
    className: String,
    tabs: Array,
    tab: String,
  },
  components: {
    // InfoBlock,
    // Formm,
    // FormOpening,
  },
  data () {
    return {
      name: 'form-opening',
      loading: false,
      isDesktop: true,
      isDevOrLocal: (Constants.isDev || Constants.isLocalhost),
      // data
      intab: undefined,
    }
  },
  computed: {
    _: function () {
      return _
    },

    Util: function () {
      return Util
    },
  },
  watch: {
    'tab': function () {
      this.intab = this.tab
    },
  },
  created () {
  },
  async mounted () {
    this.intab = this.tab
    await this.ariaUpdate()
  },
  methods: {
    async ariaUpdate () {
      await this.$nextTick()
      ElementHelper.byClass(`component-tabs`, document, (elem) => {
        ElementHelper.byClass('el-tabs__item', elem, (item) => {
          item.setAttribute('role', 'button')
          item.setAttribute('tabindex', '0')
        })
      })
    },

    async onChangeTab (tab) {
      this.$emit('change-tab', this.intab)
      await this.ariaUpdate()
    },
  },
}
</script>

<style lang="scss" src="../styles/base.scss"></style>
<style lang="scss">
@import "../styles/app_setting.scss";

.component-tabs {
  .el-tabs__header {
    margin: 0;
  }

  .el-tabs__item {
    color: $color-primary-green;
    font-weight: bold;
  }

  .el-tabs__item.is-active {
    color: white;
    background-color: $color-primary-green;
  }

  &.el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: 0px;
  }

  // &.el-tabs--card > .el-tabs__header {
  //   border-bottom: 0px;
  // }
}

</style>
